module.exports = __webpack_public_path__ + "img/progressbar-icon.2bd194fa.svg";